<template>
  <div v-html="text"></div>
</template>

<script setup lang="ts">
defineProps<{
  text?: string | null | undefined;
}>();
</script>

<style scoped>
:deep(ol),
:deep(ul) {
  margin: revert;
  padding: revert;
  list-style: revert;
}
:deep(h1),
:deep(h2),
:deep(h3),
:deep(h4),
:deep(h5),
:deep(h6) {
  font-weight: revert;
  font-size: revert;
}
</style>
